<template>
  <div
    class="flex w-min flex-col space-y-4 bg-transparent px-5 *:cursor-pointer"
    data-cy="borrower-platform-controls"
  >
    <component
      :is="icon.component"
      v-for="icon in icons"
      :key="icon.name"
      :data-cy="icon.name"
      @click="icon.handler"
    />
  </div>
</template>

<script setup lang="ts">
import { ExternalEvent, useEvents } from "@/composables/events";
import IconClose from "@/components/icons/IconClose.vue";

const { emitExternally } = useEvents();

const icons = [
  {
    name: "closePlatformButton",
    component: IconClose,
    handler: () => emitExternally(ExternalEvent.CloseBorrowerPlatform),
  },
];
</script>
